import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LockIcon from '@mui/icons-material/Lock';

const AuthContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

const IconContainer = styled(Box)(({ theme }) => ({
  marginBottom: '2rem',
  padding: '1.5rem',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const AuthSplashScreen = () => {
  return (
    <AuthContainer>
      <IconContainer>
        <LockIcon 
          sx={{ 
            fontSize: '3rem',
            color: 'primary.main'
          }} 
        />
      </IconContainer>
      <CircularProgress color="primary" size={40} />
      <Typography
        variant="h6"
        sx={{
          mt: 2,
          color: 'text.secondary',
        }}
      >
        Verifying your credentials...
      </Typography>
    </AuthContainer>
  );
};

export default AuthSplashScreen; 